/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UmbrellaIdentitySignupRequest
 */
export interface UmbrellaIdentitySignupRequest {
    /**
     * 
     * @type {string}
     * @memberof UmbrellaIdentitySignupRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UmbrellaIdentitySignupRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UmbrellaIdentitySignupRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UmbrellaIdentitySignupRequest
     */
    password: string;
    /**
     * 
     * @type {boolean}
     * @memberof UmbrellaIdentitySignupRequest
     */
    optOutFromNews: boolean;
}

/**
 * Check if a given object implements the UmbrellaIdentitySignupRequest interface.
 */
export function instanceOfUmbrellaIdentitySignupRequest(value: object): value is UmbrellaIdentitySignupRequest {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('optOutFromNews' in value) || value['optOutFromNews'] === undefined) return false;
    return true;
}

export function UmbrellaIdentitySignupRequestFromJSON(json: any): UmbrellaIdentitySignupRequest {
    return UmbrellaIdentitySignupRequestFromJSONTyped(json, false);
}

export function UmbrellaIdentitySignupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UmbrellaIdentitySignupRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'password': json['password'],
        'optOutFromNews': json['optOutFromNews'],
    };
}

export function UmbrellaIdentitySignupRequestToJSON(value?: UmbrellaIdentitySignupRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'password': value['password'],
        'optOutFromNews': value['optOutFromNews'],
    };
}

